import surfBackground from "./home-bg-surf.jpg";
import skateBackground from "./home-bg-skate.jpg";
import snowBackground from "./home-bg-snow.jpg";
import mountainBackground from "./home-bg-mountain.jpg";
import { useMostRecentOrganisation } from "./useRecentOrganisations";

const waterSports = ["surf", "wake", "skim", "bodyboard", "paddle", "windsurf"];
const skateSports = ["skate", "bmx", "scooter", "sls"];
const snowSports = ["snow", "freeride"];
const mountainSports = ["fmb"];

const sportTypeBackgrounds: Record<string, string> = {
    ...Object.fromEntries(waterSports.map(sport => [sport, surfBackground])),
    ...Object.fromEntries(skateSports.map(sport => [sport, skateBackground])),
    ...Object.fromEntries(snowSports.map(sport => [sport, snowBackground])),
    ...Object.fromEntries(mountainSports.map(sport => [sport, mountainBackground]))
};

const allBackgrounds = [
    surfBackground,
    skateBackground,
    snowBackground,
    mountainBackground
];

export const useHeaderBackground = () => {
    const mostRecentOrg = useMostRecentOrganisation();

    const sportType = mostRecentOrg?.sportType?.toLowerCase();

    if (!sportType || sportType === "other" || !sportTypeBackgrounds[sportType]) {
        return allBackgrounds[Math.floor(Math.random() * allBackgrounds.length)];
    }

    return sportTypeBackgrounds[sportType];
};
